var Module = {
    name: 'userInteractEvent',
    eventName: 'lh_user_interacted',
    cookieName: 'lh_real_user',
    isUserInteracted: false,
    isDocumentReady: false,

    init() {
        $(document).on(Module.eventName, () => {
            if (!Module.getCookie()) {
                Module.setCookie();
            }
        });

        $(document).one('mousemove click scroll', () => {
            Module.isUserInteracted = true;
            if (Module.isDocumentReady) {
                Module.dispatch();
            } 
        });

        $(() => {
            Module.isDocumentReady = true;
            if (Module.isUserInteracted) {
                Module.dispatch();
            } 
        });
    },

    dispatch() {
        $(document).trigger(Module.eventName);
    },

    setCookie() {
        let expirationTimeSeconds = 12 * 2592000 * 1000;
        let date = new Date();
        date.setTime(date.getTime() + expirationTimeSeconds);
        let expires = "; expires=" + date.toUTCString();
        document.cookie = Module.cookieName + "=1" + expires + "; path=/";
    },

    getCookie() {
        let matches = document.cookie.match(new RegExp( "(?:^|; )" + Module.cookieName.replace( /([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1' ) + "=([^;]*)" ));
        return matches ? matches[1] : null;
    }
}

module.exports = Module
